import ProofOfInvestment from "./proofOfInvestment";
export default ProofOfInvestment;